import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
	switchTab(el) {
		let element = el.target;
		//if clicked element is SVG or A element, select the parent DIV
		if ((element.tagName === 'A') | (element.tagName === 'svg')) element = element.parentElement;
		if (element.tagName === 'use') element = element.parentElement.parentElement;
		let tabName = element.dataset.tab;

		if (element.classList.contains('active-tab')) {
			element.classList.remove('active-tab');
			element.classList.add('non-active-tab');
		} else if (element.classList.contains('non-active-tab')) {
			document.querySelectorAll(['.active-tab']).forEach((el) => {
				el.classList.remove('active-tab');
				el.classList.add('non-active-tab');
			});
			element.classList.remove('non-active-tab');
			element.classList.add('active-tab');
		}

		//hide all content
		document.querySelectorAll('[data-tab-content]').forEach((el) => el.classList.add('hidden'));
		//hide parent container
		document.querySelector('[data-tab-content]').parentElement.classList.add('max-lg:hidden');
		//show clicked content
		if (element.classList.contains('active-tab')) {
			document.querySelector(`[data-tab-content = "${tabName}"]`).classList.remove('hidden');
			//show parent container
			document.querySelector('[data-tab-content]').parentElement.classList.remove('max-lg:hidden');
		}
	}
}
